import React from 'react';
import { Query, ApolloProvider } from 'react-apollo';
import gql from 'graphql-tag';
import { SnackbarProvider } from 'notistack';
import { IntlProvider } from 'react-intl';
import CircularProgress from '@material-ui/core/CircularProgress';
import client from '../lib/apolloClient';
import getMessages from '../lib/i18n/getMessages';
import Vault from '../components/Vault/Vault';
import SingleColumnTemplate from '../../../ui/layouts/SingleColumnTemplate';
import { CurrencyProvider } from '../hooks/useCurrency';

// GraphQL query to get vault documents
const GET_VAULT_DOCUMENTS = gql`
  query GetVaultDocuments {
    vaultDocuments {
      id
      title
      description
      category
      tags
      shared_with_negotiating
      source_type
      source_id
      created_at
      updated_at
      can_delete
      document {
        id
        name
        file_size
        download_url
        created_at
        uploaded_by {
          id
          name
        }
      }
      file_name
      file_size
      download_url
      uploaded_by_name
      sprint_name
    }
  }
`;

// Simple loading spinner component
const SimpleLoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
    <CircularProgress />
  </div>
);

const VaultContainer = (props, railsContext) => {
  const locale = railsContext?.i18nLocale || 'en';
  window.locale = locale;
  window.currency = railsContext?.currency;

  return (
    <CurrencyProvider currency={railsContext?.currency || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
      <SnackbarProvider maxSnack={3}>
        <ApolloProvider client={client}>
          <Query query={GET_VAULT_DOCUMENTS} fetchPolicy="network-only">
            {({ loading, error, data, refetch }) => {
              if (loading) {
                return (
                  <SingleColumnTemplate variant="wide">
                    <SimpleLoadingSpinner />
                  </SingleColumnTemplate>
                );
              }

              if (error) {
                console.error('Error loading vault documents:', error);
                return (
                  <SingleColumnTemplate variant="wide">
                    <div className="text-succession-text-secondary">
                      Error loading vault documents: {error.message}
                    </div>
                  </SingleColumnTemplate>
                );
              }

              return (
                <SingleColumnTemplate variant="wide">
                  <Vault
                    documents={data?.vaultDocuments || []}
                    refetch={refetch}
                    {...props}
                  />
                </SingleColumnTemplate>
              );
            }}
          </Query>
        </ApolloProvider>
      </SnackbarProvider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default VaultContainer;

